import { format } from 'date-fns'

export const getLocalDateTime = (date: number | Date | string) => {
  const localDate = new Date(date)
  const offset = localDate.getTimezoneOffset() * 60000

  return new Date(localDate.getTime() - offset)
}

export enum DateUnit {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export const formatDateByUnit = (date: Date, unit: DateUnit) => {
  switch (unit) {
    case DateUnit.Daily:
      return format(date, 'dd MMM yyyy')
    case DateUnit.Weekly:
      return format(date, 'dd MMM yyyy')
    case DateUnit.Monthly:
      return format(date, 'MMM yyyy')
    case DateUnit.Yearly:
      return format(date, 'yyyy')
    default:
      return ''
  }
}
